import { StyledInputAdornment } from './InputAdornment.styles';

export default StyledInputAdornment;
